export default __webpack_public_path__ + "static/media/auto-complete-variants.696910f8.png";